import { render, staticRenderFns } from "./TextareaSimpleNew.vue?vue&type=template&id=fb23c788&scoped=true&"
import script from "./TextareaSimpleNew.vue?vue&type=script&lang=js&"
export * from "./TextareaSimpleNew.vue?vue&type=script&lang=js&"
import style0 from "./TextareaSimpleNew.vue?vue&type=style&index=0&id=fb23c788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb23c788",
  null
  
)

export default component.exports